import React from 'react';

// The facts a page is about, in a row of design-system chips: "Client Quick Quack Car Wash", "Office BARE US"…
// facts are { label, value }, and a value may be an element (a link, a user's name). A fact without a value is left
// out, and with none left the row is too.
export default function FactChips({ facts = [] }) {
  const shownFacts = facts.filter((fact) => fact.value !== null && fact.value !== undefined && fact.value !== '');
  if (shownFacts.length === 0) {
    return null;
  }

  return (
    <div className='facts-row'>
      {shownFacts.map((fact) => (
        <span
          key={fact.label}
          className='chip'
        >
          {fact.label} <b>{fact.value}</b>
        </span>
      ))}
    </div>
  );
}
